module.exports = __webpack_public_path__ + "static/media/CL 11-14.60b6ec6a.mp3";